import { jsx as _jsx } from "react/jsx-runtime";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useCustomTranslation } from "@plansoft-configuration-renderer/localization";

import { useButtonUiImageIcons } from "./useButtonUiImageIcons";

export function ButtonUi(props) {
  const {
    buttonFullWidth,
    buttonColor,
    buttonText,
    buttonVariant,
    wrapperSxProps,
    onClick,
  } = props;
  const { t } = useCustomTranslation();
  const { startIcon, endIcon } = useButtonUiImageIcons(props);
  return _jsx(Box, {
    sx: wrapperSxProps,
    children: _jsx(Button, {
      startIcon: startIcon,
      endIcon: endIcon,
      color: buttonColor,
      variant: buttonVariant,
      onClick: onClick,
      fullWidth: buttonFullWidth,
      disabled: props.disabled,
      children: t(buttonText),
    }),
  });
}
//# sourceMappingURL=ButtonUi.js.map
